import React from 'react';
import {
    CORONAVIRUS_HEADER,
    CORONAVIRUS_BODY,
} from '../../constants/bannerCopy';

import Banner from '../Banner';

const CoronavirusBanner = () => {
    return (
        <Banner leftAccentColor="#F05537" header={CORONAVIRUS_HEADER}>
            <span
                //eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: CORONAVIRUS_BODY,
                }}
            />
        </Banner>
    );
};

export default CoronavirusBanner;
